import React from 'react'
import Link from 'gatsby-link'
import Avatar from '../../images/avatar.jpg'






class ProjectCard extends React.Component {

  


  render() {

    return (
      <div>
        
        <a style={{textDecoration: 'none'}} href={this.props.link} target="_blank">
            <div className="project-card" id={this.props.id}>
                <div className="project-text">
                    <h4 className="project-name">{this.props.name}</h4>
                    <p className="project-link">View project</p>
                </div>

            </div>    
        </a>
       
      </div>
    )

  }

}

export default ProjectCard



// WEBPACK FOOTER //
// ./src/components/ProjectCard/index.js